import { render, staticRenderFns } from "./VgInvoicePopupPicker.vue?vue&type=template&id=daa5b52a&scoped=true&"
import script from "./VgInvoicePopupPicker.vue?vue&type=script&lang=js&"
export * from "./VgInvoicePopupPicker.vue?vue&type=script&lang=js&"
import style0 from "./VgInvoicePopupPicker.vue?vue&type=style&index=0&id=daa5b52a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa5b52a",
  null
  
)

export default component.exports